import React, { useState } from "react";
import { Form, InputGroup, ProgressBar } from "react-bootstrap";
import {
  calculatePasswordSecurity,
  checkPasswordStrength,
} from "./passwordUtils";

const PasswordInput = () => {
  const [password, setPassword] = useState("");

  const strength = checkPasswordStrength(password);
  const security = calculatePasswordSecurity(password);

  const getProgressBarVariant = () => {
    switch (strength) {
      case "Schwach":
        return "danger";
      case "Mittel":
        return "warning";
      case "Stark":
        return "success";
      default:
        return "info";
    }
  };

  return (
    <Form>
      <Form.Group>
        <Form.Label>Passwort</Form.Label>
        <InputGroup>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Gib ein Passwort ein"
          />
        </InputGroup>
      </Form.Group>

      <ProgressBar
        variant={getProgressBarVariant()}
        now={Math.min(password.length * 8, 100)}
        label={strength}
        style={{ "20px": "20px", padding: "0rem", fontSize: "1rem", minHeight: "2.5rem" }}
        className="mt-3"
      />

      <div className="mt-4 text-center">
    <div className="fw-medium">
  Mögliche Varianten: {security.combinations}
</div>

{password.length > 1 && (
  <div className="mt-2 text-muted">
    Durch das neue Zeichen gibt es {security.growthFactor}-mal so viele Kombinationsmöglichkeiten mehr Möglichkeiten wie zuvor. 
  </div>
)}

      </div>
    </Form>
  );
};

export default PasswordInput;

